import { VALIDATE_EMAIL, VALIDATE_EMAIL_CLEAR } from "../../common/constants";

export function _validateEmail(email, status = "", username) {
  // console.log(email);

  return {
    type: VALIDATE_EMAIL,
    email,
    status,
    username,
  };
}



export function _clearEmail() {
  return {
    type: VALIDATE_EMAIL_CLEAR
  }
}


// WEBPACK FOOTER //
// ./src/Containers/SingleEmailValidation/actions.js